export function getCsrfParam(): string {
  return document.querySelector("meta[name='csrf-param']")?.getAttribute('content') || 'authenticity_token';
}

export function getCsrfToken(): string {
  return document.querySelector("meta[name='csrf-token']")?.getAttribute('content') || '';
}
